import styled from "styled-components";
import {
  COLORS,
  responsive,
  tabletAboveRange,
} from "../../../../styles/constants.style";

export const InputTransferDetailsWrapper = styled.div`
  .radio-button-container {
    margin-top: 10px;
  }

  .transfer-filed {
    margin: 24px 16px;
    width: 320px;
  }
  .program-form {
    padding-left: 16px;
    .grid-size-medium:nth-child(-n + 3) {
      margin-top: 16px;
    }
  }
  .participant-details {
    margin-top: 20px;
    background-color: ${COLORS.primary_light_blue2};
    min-height: 40px;
    height: 40px;
    padding-left: 0px;
    box-shadow: none;
    border: none;
    align-items: center;
    display: flex;
    margin-bottom: 20px;
  }
  .participant-details-label {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
    margin-left: 10px;
  }
  .participant-container {
    margin-left: 16px;
    padding-bottom: 16px;

    .grid-size-medium:nth-child(-n + 3) {
      margin-top: 0px;
      ${tabletAboveRange`
        &:nth-child(3) {
          margin-top: 24px;
        }
      `}
    }

    ${responsive.MOBILE`
      margin: 16px;
      gap: 16px;
    `}
  }
  .dot-container {
    border-top: 1px dashed ${COLORS.primary_light_blue};
  }
`;
